import { Text } from '@mantine/core';

type StorageIndicatorProps = {
  storageLeft: number;
  storageLimit: number;
  className: string;
};

export default function StorageIndicator({
  storageLeft,
  storageLimit,
  className,
}: StorageIndicatorProps) {
  const storageLimitB = storageLimit * 1024 * 1024 * 1024;
  const storagePercentage = Number(
    Math.max(100 - (storageLeft / storageLimitB) * 100, 0)
  ).toFixed(0);

  return (
    <Text c='gray.6' className={className}>
      Available storage: {storageLimit}GB ({storagePercentage}% used)
    </Text>
  );
}
